export default "__VITE_ASSET__D7b6UEWf__"